import React from 'react';
import { Table, Button, Input, Icon, Card, Dropdown, Menu, Modal, message, Popconfirm, Form } from 'antd';
import common from '../../assets/common.js';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';

const FormItem = Form.Item;
class Builder extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      batchList : [],
      search : "",
      modalType : "",
      modalData : "",
      visible: false,
      pwdUrl:"",
      passWDInfo: "",
      info:{},
      pwdVisible: false
    }
  }
  componentWillMount(){
    this.showTableCol();
  }
  componentDidMount(){
    this.getList();
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '姓名',
      dataIndex: 'realName',
      must: true,
      show: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div className="custom-filter-dropdown">
          <Input
            ref={ele => this.searchInput = ele}
            placeholder="请输入姓名"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={this.handleSearch(selectedKeys, confirm)}
          />
          <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>搜索</Button>
          <Button onClick={this.handleReset(clearFilters)}>重置</Button>
        </div>
      ),
      filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
      onFilter: (value, record) => record.realName.toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus();
          });
        }
      },
      render: (text) => {
        const { searchText } = this.state;
        return searchText ? (
          <span>
            {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
              fragment.toLowerCase() === searchText.toLowerCase()
                ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
            ))}
          </span>
        ) : text;
      },
    }, {
      title: '部门',
      dataIndex: 'deptName',
      must: false,
      show: true,
    }, {
      title: '备注',
      dataIndex: 'remark',
      must: false,
      show: true,
    }, {
      title: '密码',
      must: false,
      show: true,
      render: (text, record) => {
        return (
          <a target="_blank" rel="noopener noreferrer" onClick={this.checkPassWord.bind(this, record.id)}>查看</a>
        )
      }
    },{
      title: '状态',
      must: false,
      show: true,
      render: (text, record) => {
        return (
          <span>{record.status==="VALID"?"已启用":"已禁用"}</span>
        )
      }
    }, {
      title: '账号',
      dataIndex: 'userName',
      must: true,
      show: true,
      width : "120px"
    }, {
      title:'操作',
      key:"action",
      must: true,
      show: true,
      width: "120px",
      render: (text, record)=>{
        const menu = (
          <Menu>
            <Menu.Item>
              <a target="_blank" rel="noopener noreferrer" onClick={()=> this.modalShowl(record)}>修改</a>
            </Menu.Item>
            <Menu.Item>
              <Popconfirm title="确定要删除此施工人员？" okText="是" cancelText="否" onConfirm={() => this.deletePeople(record.id)}>
                <a className="wrap">删除</a>
              </Popconfirm>
            </Menu.Item>
            <Menu.Item>
              <a target="_blank" rel="noopener noreferrer" onClick={()=> this.disable(record)}>{record.status==="VALID"?"禁用":"启用"}</a>
            </Menu.Item>
          </Menu>
        );
        return(
          <Dropdown overlay={menu}>
            <div className="ant-dropdown-link">
            更多<Icon type="down" />
            </div>
          </Dropdown>
        )
      }
    }];
    table = common.getEcardTable(table);
    this.setState({ table });
  }
  deletePeople = (id) => {
    var postData = {};
    postData["_url"] = "api/construct/user?id=" + id;
    postData["_method"] = "DELETE";
    common.request(postData, this, function(obj, data){
      message.info("操作成功");
      obj.getList();
    },function(obj, state){
    });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  checkPassWord = (id) => {
    var postData = {};
    postData["_url"] = "api/construct/user/pwd?id=" + id;
    common.request(postData, this, function(obj, data){
      obj.setState({
        pwdVisible: true,
        pwd: data.result.passWord
      })
    },function(obj, state){
    });
  }
  getList = (pageInfo, filters, sorter) =>{
    const pn = pageInfo ? pageInfo :  1;
    const batchId = this.state.batchId;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/construct/user/search";
    postData["key"] = batchId;
    postData["pageNum"] = pn;
    postData["key"] = this.state.searchText;
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
    // console.log(selectedKeys[0]);
    this.showTableCol();
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  changeBatch = (batchId) => {
    this.setState({ batchId }, function(){
      this.getList()
    })
  }
  updateBuilder = (record)=> {
    let postData = {};
    postData["_url"] = 'api/admin/code';
    postData["_method"] = 'GET';
    common.request(postData, this, function(obj, result){
      obj.setState({
        code: result.result,
        visible: true,
        orgName: record.orgName,
        pwdUrl: window.location.protocol+'//'+window.location.host+"/acs/api/admin/pwdcode/"+ record.orgId +"/img?id=" + result.result,
      });
      obj.setInt(record.orgId);
    },function(obj, data){
      message.warning(data.message);
    });
  }
  modalShowl = (info)=> {
    this.setState({
      visible: true,
      info:info
    });
  }
  returnAdd = () => {
    window.location.href = "#/builder/add";
  }
  handleSubmit = (e) => {
    let this_ = this;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this_.submit(values);
      }
    });
  }
  submit = (values) => {
    let postData = values;
    postData["_url"] = 'api/construct/user?id='+ this.state.info.constructUserId;
    postData["_method"] = 'PUT';
    common.request(postData, this, function(obj, result){
      message.info("修改成功");
      obj.setState({
        visible: false
      });
      obj.getList();
      // window.location.href = "#/builder";
    },function(obj, data){
      message.warning(data.message);
    });
  }
  handleCancel = () => {
    this.setState({
      visible: false
    })
  }
  handleCancelPwd = () => {
    this.setState({
      pwdVisible: false
    })
  }
  disable = (record) => {
    let postData = {};
    if(record.status === "VALID") {
      postData["_url"] = "api/construct/user/disable";
    } else {
      postData["_url"] = 'api/construct/user/enable';
    }
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      message.info("操作成功");
      obj.getList();
    },function(obj, data){
      message.warning(data.message);
    });
  }
  render(){
    const { table } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {xs: { span: 24 },sm: { span: 6 },},
      wrapperCol: {xs: { span: 24 },sm: { span: 14 },},
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return(
      <Card>
        <div>
          <Button type="primary" onClick={this.returnAdd} style={{marginBottom: '15px'}}><Icon type="plus" />新增施工人员</Button>
          <Button type="primary" style={{marginBottom: '15px',float: 'right'}}><a href='images/code.png' download>下载手机端登录二维码</a></Button>
          <div className="table-menu clearfix">
            <div className="pull-right">
            { table.show && <MenuAction obj={ this }/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>
          <Modal
            title="查看密码"
            visible={this.state.pwdVisible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancelPwd}
            footer={[
              <Button onClick={this.handleCancelPwd}>关闭</Button>
            ]}
          >
          {this.state.pwd}
          </Modal>
          <Modal
            title="修改信息"
            visible={this.state.visible}
            centered={true}
            className="text-center"
            destroyOnClose={true}
            onCancel={this.handleCancel}
            footer={null}
          >
            <Form onSubmit={this.handleSubmit}>
              <FormItem
                {...formItemLayout}
                label="姓名"
              >
                {getFieldDecorator('realName', {
                  rules: [{
                    required: true, message: '请填写施工人员姓名!',
                  }],
                  initialValue: this.state.info?this.state.info.realName:''
                })(
                  <Input />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="账号"
              >
                {getFieldDecorator('userName', {
                  rules: [{
                    required: true, message: '请填写施工人员账号!',
                  }],
                  initialValue: this.state.info?this.state.info.userName:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="密码"
              >
                {getFieldDecorator('passWord', {
                  rules: [{
                    required: true, message: '请填写施工人员密码!',
                  }],
                  initialValue: this.state.info?this.state.info.passWord:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="部门"
              >
                {getFieldDecorator('deptName', {
                  rules: [{
                    required: true, message: '请填写施工人员所在部门!',
                  }],
                  initialValue: this.state.info?this.state.info.deptName:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="备注"
              >
                {getFieldDecorator('remark', {
                  rules: [{
                    message: '请填写备注!',
                  }],
                  initialValue: this.state.info?this.state.info.remark:''
                })(
                  <Input type="text" />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit">修改</Button>
              </FormItem>
            </Form>
          </Modal>
        </div>
      </Card>
    )
  }
}
const BuilderForm = Form.create()(Builder);
export default BuilderForm;



// WEBPACK FOOTER //
// ./src/component/builder/list.js